// brackets for bindings parser
export default {
    left: '{{',
    right: '}}'
};
